import { render, staticRenderFns } from "./notsignedin-social-sign-on.vue?vue&type=template&id=ddcac738&scoped=true"
import script from "./notsignedin-social-sign-on.vue?vue&type=script&lang=js"
export * from "./notsignedin-social-sign-on.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcac738",
  null
  
)

export default component.exports